import { publicEnv } from "@/config/publicEnv";

function isDev(): boolean {
  return publicEnv.NEXT_PUBLIC_ENVIRONMENT_TYPE === "dev";
}

export function isProduction(): boolean {
  return publicEnv.NEXT_PUBLIC_ENVIRONMENT_TYPE === "prod";
}

function isTesting(): boolean {
  return publicEnv.NEXT_PUBLIC_ENVIRONMENT_TYPE === "testing";
}

export function isTestingOrDev(): boolean {
  return isTesting() || isDev();
}
